export default "__VITE_ASSET__CjYKJcK___"